import { imageHeroSlider, tabTarget } from './components/index';
import { initScreenHeight } from './helpers/screenHeight';
import {
	inViewVideoTarget,
	latestNewsCalloutTarget,
	statTarget,
	videoWithControlsTarget,
	videoEmbedWithControlsTarget,
	modalContainerTarget,
	announcementStrip,
	headerTarget,
	accordionsContainerTarget,
	textImageCarouselSwiperTargetLeft,
	textImageCarouselSwiperTargetRight,
	teamCarouselSwiperTarget,
	dataPostListingTarget,
	dataSearchResultList,
	paginationTarget
} from './components';

initScreenHeight();

// Load Events
jQuery(document).ready(() => {

	if ($(tabTarget).length) {
		import('./components/tabbedContent').then(module => {
			module.initTabbedContent();
		});
	}

	if ($(paginationTarget).length) {
		import('./components/pagination').then(module => {
			module.initPagination();
		});
	}

	if ($(statTarget).length) {
		import('./components/stats').then(module => {
			module.initStats();
		});
	}

	if ($(latestNewsCalloutTarget).length) {
		import('./components/latestNewsCalloutCarousel').then(module => {
			module.initLatestNewsCalloutSlider();
		});
	}

	if ($(videoWithControlsTarget).length) {
		import('./components/videoWithControls').then(module => {
			module.initVideoControls();
		});
	}

	if ($(videoEmbedWithControlsTarget).length) {
		import('./components/videoWithControls').then(module => {
			module.initVideoControls();
		});
	}

	if ($(inViewVideoTarget).length) {
		import('./components/inViewVideo').then(module => {
			module.initInViewVideo();
		});
	}

	if ($(modalContainerTarget).length) {
		import('./components/modal').then(module => {
			module.initModal();
		});
	}

	if ($(announcementStrip).length) {
		import('./components/strip').then(module => {
			module.initStrip();
		});
	}

	if ($(imageHeroSlider).length) {
		import('./components/imageHero').then(module => {
			module.initImageHeroCarousel();
		});
	}

	if ($(headerTarget).length) {
		import('./components/header').then(module => {
			module.initHeader();
		});
	}

	if ($(accordionsContainerTarget).length) {
		import('./components/accordion').then(module => {
			module.initAccordions();
		});
	}

	if ($(textImageCarouselSwiperTargetLeft).length) {
		import('./components/textImageCarousel').then(module => {
			module.initTextImageCarouselSwiperLeft();
		});
	}

	if ($(textImageCarouselSwiperTargetRight).length) {
		import('./components/textImageCarousel').then(module => {
			module.initTextImageCarouselSwiperRight();
		});
	}

	if ($(teamCarouselSwiperTarget).length) {
		import('./components/teamCarousel').then(module => {
			module.initTeamCarousel();
		});
	}

	if ($(dataPostListingTarget).length) {
		import('./components/listingPagination').then(module => {
			module.initListingPagination();
		});
	}

	if ($(dataSearchResultList).length) {
		import('./components/search').then(module => {
			module.initSearch();
		});
	}
});



// WEBPACK FOOTER //
// ./scripts/main.ts